import { render } from "./schedule.vue?vue&type=template&id=fa52d8a8&scoped=true"
import script from "./schedule.vue?vue&type=script&lang=js"
export * from "./schedule.vue?vue&type=script&lang=js"

import "./schedule.vue?vue&type=style&index=0&id=fa52d8a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa52d8a8"]])

export default __exports__